import { render, staticRenderFns } from "./ShowSpecialDeals.vue?vue&type=template&id=b68d464c"
import script from "./ShowSpecialDeals.vue?vue&type=script&lang=js"
export * from "./ShowSpecialDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports